module.exports = __webpack_public_path__ + "img/type-window-11mm.a97da44a.png";